import { GuideViewInsight } from "@/components/guide-view-insight/GuideViewInsight";

const GuideViewInsightPage = () => <GuideViewInsight />;

export default GuideViewInsightPage;
